import { Button } from "antd";
import React from "react";
import { useNavigate } from "react-router";

import errorBoundary from "../../assets/images/error-boundary.svg";

interface ContentErrorUiInterface { }

const ContentErrorUi: React.FC<ContentErrorUiInterface> = () => {
  const navigate = useNavigate();

  return (
    <div className="content-error">
      <div className="content-error_heading-wrapper">
        <img src={errorBoundary} alt="" width={350} />
        <span>Oops!</span>
        <p>Something Went Wrong</p>
        <Button
          type="primary"
          onClick={() => {
            window.location.replace("/store")
          }}
        >
          Go To Home
        </Button>
      </div>
    </div>
  );
};

export default ContentErrorUi;
